import React, { forwardRef } from 'react';
import { cn } from '@ais-ui/utils';

export type KbdProps = React.HTMLAttributes<HTMLElement>;

export const Kbd = forwardRef<HTMLElement, KbdProps>(
  ({ children, className, ...props }, ref): React.JSX.Element => {
    return (
      <kbd
        {...props}
        className={cn(
          'border rounded px-2 py-1 bg-muted text-muted-foreground inline-flex items-center',
          className
        )}
        ref={ref}
      >
        {children}
      </kbd>
    );
  }
);
